import { sendEmail, sendEmailProps } from '@/api/server/common/sendEmail';
import { Button } from '@mui/material';

export default function SendEmail(payload: sendEmailProps) {
  const handleClick = async () => {
    const re: string | undefined = await sendEmail(payload);
    if (re) {
      // 이미 등록된 사용자 이메일입니다.
    }
  };
  return <Button onClick={handleClick}>전송</Button>;
}
